// --------------------------------------------------------------
// Created On: 2025-07-16
// Author: Hannah Vaughan
//
// Last Modified: 2025-07-16
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Constants related to polling data periodically.
// Note: Delay is being added to max inactivity time to account for guaranteed inactivity that is applied to the user
// that happens during each initial polling check. This cycle is required to dramatically reduce the number of
// re-renders that have to be processed.
export const SHOPPING_CART_POLLING_DELAY_SECONDS = 5;
export const SHOPPING_CART_MAX_INACTIVE_USER_SECONDS = 120 + SHOPPING_CART_POLLING_DELAY_SECONDS;
